export const boxStyle = { ml: '8px', height: '40px' }

export const TextStyle = {
  marginLeft: '8px',
  fontStyle: 'normal',
  fontSize: 14,
  lineHeight: '24px',
  fontWeight: 500,
}

export const buttonStyleSx = {
  fontFamily: 'Roboto',
  ml: '8px',
  height: '40px',
  background: '#3F51B5',
  fontSize: 14,
  fontWeight: 500,
  fontStyle: 'normal',
  lineHeight: '24px',
}
